import { useProjectDirectories } from '@/context/ProjectDirectoriesContext';

/**
 * Convenience hook to get both directory handle and path for a project
 * Reduces prop drilling by providing both values in one hook call
 * @param projectId - ID of the project
 * @returns Object with `handle` (FileSystemDirectoryHandle | null) and `path` (string | null)
 */
export function useProjectDirectory(projectId: string) {
  const { getProjectDirectory, getStoredProjectPath } = useProjectDirectories();

  const handle = getProjectDirectory(projectId);
  const path = getStoredProjectPath(projectId);

  // For sync operations, prefer path over handle
  const syncDir = path || handle;

  return {
    handle,
    path,
    syncDir, // Combined value for sync operations (prefers path)
  };
}
